import { FastField, useFormikContext } from "formik";
import React from "react";
import 'setimmediate';
function Postcode() {
  const { errors, touched } = useFormikContext();

  return (
    <div>  
      <div>
        <p>Enter your postcode to check when your next collection is due, and view the details of your garden waste subscription (if subscribed).</p>
        <p>If you live in a flat and use communal recycling bins, your collection dates may not show up. Call us on <a href="tel:01454868000">01454 868000</a> for information about your collections.</p>
        <h2>Enter your postcode</h2>
        {touched.postcode && errors.postcode && 
         <div className="validation-summary" role="alert">
         <h4>The form could not be submitted for the following reasons:</h4>
          <ul role="presentation">
            <li>Postcode is a required field</li>
          </ul>
        </div>
        }
        <FastField name="postcode" id="postcode" className="form-control input__small input-width--200"/>
      </div>
      <div className="form-footer mtop-20">  
        <button type="submit" className="button button--primary button__small">
          Continue
        </button>
      </div>
    </div>
  );
}
export default Postcode;
